import { forkJoin, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ScorecardService } from '../scorecard/core/scorecard.service';
import { PeriodType, ScorecardBoxDto } from '../scorecard/scorecard.model';
import { Dependencies } from '../store';

export function retrieveBoxesObservable(
    deps: Dependencies,
    periodTypes: PeriodType[],
    userId: number,
    scorecardId: number,
    groupId: number,
    endDate: Date,
    useLiveData: boolean,
): Observable<ScorecardBoxDto[]> {
    const service = deps.injector.get<ScorecardService>(ScorecardService);

    // TODO maybe api or db-stored-proc can one day change to accept multiple period types
    const reqs = periodTypes.map((e) => {
        return service.retrieveBox(
            userId,
            e,
            scorecardId,
            groupId,
            endDate,
            useLiveData,
        );
    });
    return forkJoin(reqs).pipe(
        map((rets) => {
            return rets.filter((e) => e != null);
        }),
    );
}
